import { createContext, useContext } from "react";
export function factoryLanguageContext(req) {
  return {
    language: req.language
  };
}
var LanguageContext = /*#__PURE__*/createContext({
  language: "en"
});
export var useLang = function useLang() {
  if (__IS_CSR__) {
    return window.language;
  }
  return useContext(LanguageContext).language;
};
export default LanguageContext;